/**
 * Today's calendar date in the browser's timezone, as YYYY-MM-DD.
 * `toISOString().split('T')[0]` is UTC and flips after evening in the US.
 */
export function localDateOnly(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA').format(date);
}
